<template>
	<div class="v5-spinner-circles" :style="{ 'width':size, 'height':size}"></div>
</template>

<script>
	export default {
		name: 'v5-spinner-circles',
		props: {
			size: {
				type: String,
				default: '30px'
			}
		}
	};

</script>

<style lang="scss">
	@import '../style.scss';
	.v5-spinner-circles {
		display: inline-block;
	}

	.v5-spinner-circles:after {
		content: " ";
		display: block;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		border: 3px solid $color;
		box-sizing: border-box;
		border-color: $color transparent $color transparent;
		animation: v5-spinner-circles 1.2s linear infinite;
	}

	@keyframes v5-spinner-circles {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

</style>
